export default "__VITE_ASSET__C6T8WP7e__"